<template>
  <div>
       <a-card :title="$t('all_meetings')" :bordered="false" style="width: auto">
        <a-tabs default-active-key="1" v-if="hasMeetings">
          <a-tab-pane key="1" :tab="$t('upcomming_meetings')">
              <table class="table table-striped" v-if="count_up_meetings > 0">

                <thead>
                  <tr>
                    <th>Meeting Name</th>
                    <th>Start Time</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody >
                  <tr v-for="item in meetings" :key="item.id" >
                    <td>{{item.topic}}</td>
                    <td>{{ moment(item.start_time).utcOffset(0).format('LLLL')}}</td>
                    <td>
                        <router-link :to="{ path: '/meeting/'+item.meeting_id}" class="btn-info btn-sm" exact>Details</router-link> |
                        <a :href="item.start_url" target="_blank">
                          <a-button size="small" type="primary">Start</a-button>
                        </a> | 
                        <a-button size="small" type="danger" @click="deleteMeeting(item.meeting_id)">Delete
                        </a-button>
                    </td>
                  </tr>
                </tbody>
            </table>
             <a-empty v-else>  <span slot="description">No upcoming meetings! </span></a-empty>
            <!-- <a-pagination size="small" :total="50"  @change="onChangePagination"/> -->
          </a-tab-pane>
          <a-tab-pane key="2" :tab="$t('previos_meetings')" force-render>
              <table class="table table-striped" v-if="count_prv_meetings > 0">
                  <thead>
                    <tr>
                      <th>Meeting Name</th>
                      <th>Start Time</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody >
                    <tr v-for="item in previous_meeting" :key="item.meeting_id" >
                      <td>{{item.topic}}</td>
                      <td>{{ moment(item.start_time).utcOffset(0).format('LLLL')}}</td>
                      <td>
                        <router-link :to="{ path: '/meeting/'+item.meeting_id}" class="btn-info btn-sm" exact>Details</router-link>
                         | <a-button size="small" type="danger" @click="deleteMeeting(item.meeting_id)">Delete</a-button></td>
                    </tr>
                  </tbody>
              </table>
              <a-empty v-else>  <span slot="description">No previous meetings! </span></a-empty>
          </a-tab-pane>
          <a-tab-pane key="3" :tab="$t('instant_meetings')" force-render>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>Meeting Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody v-if="count_ins_meetings">
                    <tr v-for="item in instant_meeting" :key="item.meeting_id" >
                      <td>{{item.topic}}</td>
                      <td><a :href="item.start_url" target="_blank">
                        <a-button size="small" type="primary">Start</a-button></a> | 
                        <a-button size="small" type="danger" @click="deleteMeeting(item.meeting_id)">Delete</a-button></td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                  <tr>
                    <td colspan="5">No instant meetings</td>
                  </tr>
                </tbody>
              </table>
          </a-tab-pane>
        </a-tabs>
       </a-card>
       <div class="card-footer">
          <!-- <a-button type="primary" @click="updateMeetings">{{$t('update_meetings')}}</a-button> -->
        </div>
  </div>
</template>
<script>
import API from '../services/api';
import moment from 'moment';
import store from '../store'
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {
      data_now: moment(new Date).format(),
      user: {
        name: "Jesse"
      },
      hasMeetings:true
    };
  },
  computed: {
    userLogin() {
      return this.$store.state.auth.user;
    },
    ...mapState({
      meetings:  state => state.meetings.meetings,
      previous_meeting: state =>  state.meetings.prv_meetings,
      instant_meeting: state =>  state.meetings.instant_meetings,
    }),

    ...mapGetters(['count_up_meetings','count_prv_meetings','count_ins_meetings'])
  },
  created(){
    
  },
  methods: {
    checkIfHasMeeting(){
      if(this.instant_meeting.length){
        this.hasMeetings = true
      }
    },
    moment,
    deleteMeeting(meeting_id) {
      this.$confirm({
        title: 'Do you want to delete this meeting?',
        content: '',
        onOk() {
          API.delete(`/meetings/${meeting_id}/delete_meeting`)
          .then(response => {
            if(response.status === 200){
              //this.openNotification('success',"Success","Meeting was deleted!")
              store.dispatch('getMeetings')
            }
          })
        },
        onCancel() {},
      });
    },
    openNotification(type,message,description) {
      this.$notification[type]({
        message: message,

        description: description,
      });
    },
    onChangePagination(value){
      this.paginate(2,value)
      //console.log(this.meetings)
    },
    paginate(page_size, page_number) {
      // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
      this.meetings =  this.meetings.slice((page_number - 1) * page_size, page_number * page_size);
    },
    async updateMeetings(){
       await this.$store.dispatch('updateMeetings')
       //await this.$store.dispatch('getMeetings')
    }
  }
};
</script>
<style>
</style>
